<template>
  <div>
    <select-shop
      :loadingButton="loadingButton"
      v-on:getData="fetchDocuments()"
    ></select-shop>
    <CCard class="shadow-sm">
      <CCardBody>
        <CRow>
          <CCol sm="12" lg="12">
            <div class="row">
              <div class="col-md-10 col-sm-9 col-8">
                <h2 class="text-dark font-weight-normal">
                  {{ documentTitle }}
                </h2>
                <!-- <h5 class="text-dark font-weight-normal">
                  {{ $t("documentsTotal") }} ({{ filteredDocuments.length }})
                </h5> -->
              </div>
              <div class="col-md-2 col-4 text-right">
                <CButton @click="navigateToCreatePage" block color="warning" style="color: white;">
                  <i class="fi fi-rr-plus" style="margin-right: 8px;"></i>
                  {{ createButtonText }}
                </CButton>
                <CButton class="mt-2" block color="info" @click="">
                  <i class="fi fi-rr-file-excel"></i> {{ $t("export") }}
                </CButton>
              </div>
            </div>
            <CTabs v-model="selectedCategory">
              <CTab
                v-for="tab in tabs"
                :key="tab.key"
                :itemKey="tab.key"
                :aria-controls="`${tab.key}-tab`"
                >
                <template #title>
                  <div @click="onTabChange(tab.key)">
                    {{ $t(tab.label) }}
                  </div>
                </template>
              </CTab>
            </CTabs>

            <!-- Filters (Search & Status Dropdown) -->
            <CRow class="mt-3">
              <CCol md="3">
                <select
                  v-model="selectedStatus"
                  :disabled="selectedCategory === 'suppliers'"
                  class="custom-select"
                >
                  <option value="all">{{ $t("allOrders") }}</option>
                  <option value="pending">{{ $t("pendingDoc") }}</option>
                  <option value="inprogress">{{ $t("inProgressDoc") }}</option>
                  <option value="completed">{{ $t("completedDoc") }}</option>
                  <option value="cancelled">{{ $t("cancelDoc") }}</option>
                </select>
              </CCol>
              <CCol sm="7">
                <CInput
                  v-model="searchQuery"
                  :placeholder="$t('keyword')"
                  @input="filterDocuments"
                />
              </CCol>
              <CCol sm="2">
                <CButton block color="success" @click="filterDocuments">
                  {{ $t("search") }}
                </CButton>
              </CCol>
            </CRow>
            <div style="overflow-x: auto">
              <CDataTable :items="filteredDocuments" :fields="currentFields" border>
                <template #status="{ item }">
                  <td>
                    <CBadge :class="getStatusColor(item.status)">
                      {{ item.status }}
                    </CBadge>
                  </td>
                </template>
                <template #action="{ item, index }">
                  <td class="text-center">
                    <CRow>
                      <CCol>
                        <img
                          :id="'' + index"
                          src="/img/file-edit.png"
                          style="width: 14px; height: 14px; cursor: pointer"
                          @click="navigateToDetailPage(item)"
                        />
                      </CCol>
                    </CRow>
                  </td>
                </template>
                <template #no-items-view>
                  <div class="text-center my-5">
                    <h4 style="color: #ced2d8">
                      {{ $t("noItem") }}
                    </h4>
                  </div>
                </template>
              </CDataTable>
            </div>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import axios from "@/services/local";
import moment from "moment";
import util from "@/util/util";

export default {
  data() {
    return {
      searchQuery: "",
      documents: [],
      products: [],
      suppliers: [],
      selectedCategory: "documents",
      selectedStatus: "all",
      loadingButton: true,
      filteredDocuments: [],
      tabs: [
        { key: "documents", label: "document" },
        { key: "products", label: "product" },
        { key: "suppliers", label: "supplier" },
      ],
    };
  },
  computed: {
    documentType() {
      return this.$route.path.includes("/pr")
        ? "PR"
        : this.$route.path.includes("/po")
        ? "PO"
        : this.$route.path.includes("/gr")
        ? "GR"
        : "";
    },
    documentTitle() {
      if (this.documentType === "PR") {
        return this.$t("prDocTxt");
      } else if (this.documentType === "PO") {
        return this.$t("poDocTxt");
      } else {
        return this.$t("grTxt");
      }
    },
    createButtonText() {
      return this.$t("createDoc");
    },
    currentFields() {
      switch (this.selectedCategory) {
        case "documents":
          return [
            { key: "createdDate", label: this.$t("createdAt"), _style: "width:15%",_classes: "text-left font-weight-normal text-dark"  },
            { key: "docNo", label: this.$t("documentNo"), _style: "width:15%",_classes: "text-left font-weight-normal text-dark" },
            { key: "supplier", label: this.$t("supplier"), _style: "width:20%",_classes: "text-left font-weight-normal text-dark" },
            { key: "dueDate", label: this.$t("dueDate"), _style: "width:15%",_classes: "text-left font-weight-normal text-dark" },
            { key: "createdBy", label: this.$t("createBy"), _style: "width:10%",_classes: "text-left font-weight-normal text-dark" },
            { key: "status", label: this.$t("status"), _style: "width:10%",_classes: "text-left font-weight-normal text-dark" },
            { key: "action", label: "", _style: "width:5%",_classes: "text-left font-weight-normal text-dark" },
          ];
        case "products":
          return [
            { key: "createdDate", label: this.$t("createdAt"), _style: "width:20%",_classes: "text-left font-weight-normal text-dark" },
            { key: "docNo", label: this.$t("documentNo"), _style: "width:20%",_classes: "text-left font-weight-normal text-dark" },
            { key: "productName", label: this.$t("productName"), _style: "width:30%",_classes: "text-left font-weight-normal text-dark" },
            { key: "totalQuantity", label: this.$t("itemCount"), _style: "width:20%",_classes: "text-left font-weight-normal text-dark" },
            { key: "status", label: this.$t("status"), _style: "width:10%",_classes: "text-left font-weight-normal text-dark" },
          ];
        case "suppliers":
          return [
            { key: "index", label: this.$t("#"), _style: "width:5%",_classes: "text-left font-weight-normal text-dark" },
            { key: "supplier", label: this.$t("supplier"), _style: "width:50%",_classes: "text-left font-weight-normal text-dark" },
            { key: "totalDocs", label: this.$t("documentQty"), _style: "width:20%",_classes: "text-left font-weight-normal text-dark" },
            { key: "totalAmount", label: this.$t("totaValue"), _style: "width:25%",_classes: "text-left font-weight-normal text-dark" },
          ];
        default:
          return [];
      }
    },
    processedDocuments() {
      let data = this.documents;
      let detail = [];
      for (let i = 0; i < data.length; i++) {
        let item = data[i];
        const docNo = item.docNo || "-";
        const createdBy = item.createdBy || "-";

        const createdDate =
          moment(String(item.created_at)).format("DD/MM/YYYY HH:mm:ss") || "-";
        const supplier = item.supplier?.name || "-";
        const checkStockName = item.note || "-";
        const status = item.status || "Pending";
        const dueDate = moment(String(item.dueDate)).format("DD/MM/YYYY") || "-";
        detail.push({
          docNo: docNo,
          createdDate: createdDate,
          checkStockName: checkStockName,
          supplier: supplier,
          createdBy: createdBy,
          status: status,
          dueDate: dueDate,
          objectId: item.objectId || "-",
          id: item.id,
        });
      }
      return detail;
    },

    processedProducts() {
      return this.products.map((doc) => ({
        createdDate: moment(doc.created_at).format("DD/MM/YYYY HH:mm:ss") || "-",
        docNo: doc.docNo || "-",
        productName: doc.productName || "-",
        totalQuantity: doc.totalQuantity || 0,
        status: doc.status || "Pending",
      }));
    },

    processedSuppliers() {
      const supplierSummary = {};
      this.suppliers.forEach((doc) => {
        const supplierName = doc.supplier || doc.supplier?.name || "-";
        if (!supplierSummary[supplierName]) {
          supplierSummary[supplierName] = {
            supplier: supplierName,
            totalDocs: 0,
            totalAmount: 0,
          };
        }
        supplierSummary[supplierName].totalDocs += 1;
        supplierSummary[supplierName].totalAmount += doc.totalAmount || 0;
      });
      return Object.values(supplierSummary).map((supplier, index) => ({
        index: index + 1, // เริ่มจาก 1
        ...supplier,
      }));
    },

    // filteredDocuments() {
    //   if (this.selectedCategory === "documents") {
    //     return this.processedDocuments;
    //   } else if (this.selectedCategory === "products") {
    //     return this.processedProducts;
    //   } else if (this.selectedCategory === "suppliers") {
    //     return this.processedSuppliers;
    //   }
    //   return [];
    // },
  },
  methods: {
    onTabChange(newTab) {
      this.selectedCategory = newTab;
    },
    fetchDocuments() {
      const uid = this.uid;
      const shopObjectId = this.shopObjectId;
      const params = { shopObjectId: shopObjectId };
      let url = "";
      let basePath = "";
      if (this.selectedCategory === "documents") {
        basePath = "alldoc";
      } else if (this.selectedCategory === "products") {
        basePath = "product";
      } else if (this.selectedCategory === "suppliers") {
        basePath = "supplier";
      }

      if (basePath) {
        if (this.documentType === "PR") {
          url = `http://localhost:3002/pr/${basePath}`;
        } else if (this.documentType === "PO") {
          url = `http://localhost:3003/po/${basePath}`;
        } else if (this.documentType === "GR") {
          url = `http://localhost:3004/gr/${basePath}`;
        }
      }

      if (!url) return;
      this.documents = [];
      const headers = { shopObjectId: this.$store.getters.shopObjectId };

      axios
        .get(url, { params, headers })
        .then((res) => {
          if (this.selectedCategory === "documents") {
            this.documents = res.data;
          } else if (this.selectedCategory === "products") {
            this.products = res.data;
          } else if (this.selectedCategory === "suppliers") {
            this.suppliers = res.data;
          }
        })
        .catch((error) => {
          console.error("Error fetching documents:", error);
        });
    },
    updateCategory() {
      this.fetchDocuments();
    },
    filterDocuments() {
      const keyword = this.searchQuery.toLowerCase();
      this.filteredDocuments = this.filteredDocuments.filter((doc) =>
        Object.values(doc).some((value) =>
          value.toString().toLowerCase().includes(keyword)
        )
      );
    },
    getStatusColor(status) {
      switch (status) {
        case "Completed":
          return "status-success"; // สี success จางลง
        case "Canceled":
          return "status-danger"; // สี danger จางลง
        case "Pending":
          return "status-light"; // สี light
        case "In Progress":
          return "status-primary"; // สี primary จางลง
        default:
          return "status-light"; // สีเทา
      }
    },
    navigateToCreatePage() {
      let path = "";
      if (this.documentType === "PR") {
        path = "/inventory/purchase/createPRDocument";
      } else if (this.documentType === "PO") {
        path = "/inventory/purchase/createPODocument";
      } else if (this.documentType === "GR") {
        path = "/inventory/purchase/createGRDocument";
      }
      if (path) {
        this.$router.push(path);
      }
    },
    navigateToDetailPage(item) {
      let path = "";
      if (this.documentType === "PR") {
        path = "/inventory/purchase/PRDocument/" + item.objectId;
      } else if (this.documentType === "PO") {
        path = "/inventory/purchase/PODocument/" + item.objectId;
      } else if (this.documentType === "GR") {
        path = "/inventory/purchase/GRDocument/" + item.objectId;
      }
      if (path) {
        this.$router.push(path);
      }
    },
  },
  created() {
    this.fetchDocuments();
  },
  watch: {
    "$route.path": {
      immediate: true,
      handler() {
        this.fetchDocuments();
      },
    },
    selectedCategory: {
      immediate: true,
      handler() {
        this.fetchDocuments(); // เรียก API โหลดข้อมูลใหม่
      },
    },
    documents: {
      handler() {
        if (this.selectedCategory === "documents") {
          this.filteredDocuments = this.processedDocuments;
        }
      },
      deep: true,
    },
    products: {
      handler() {
        if (this.selectedCategory === "products") {
          this.filteredDocuments = this.processedProducts;
        }
      },
      deep: true,
    },
    suppliers: {
      handler() {
        if (this.selectedCategory === "suppliers") {
          this.filteredDocuments = this.processedSuppliers;
        }
      },
      deep: true,
    },
  },
};
</script>
<style>
.status-success {
  background-color:#78C43E !important; /* Success จาง */
  color: #155724;
  border-radius: 10px;
}

.status-danger {
  background-color: #FF3B3B !important; /* Danger จาง */
  color: #eee;
  border-radius: 10px;
}

.status-light {
  background-color: #e0e0e0 !important; /* Light */
  color: #6c757d;
  border-radius: 10px;
}

.status-primary {
  background-color: #2C95FE !important; /* Primary จาง */
  color: #eee;
  border-radius: 10px;
}
.nav-tabs .nav-link {
  color: var(--secondary);
  border: #fff;
  background-color: #ffffff;
}
.nav-tabs .nav-link.active {
  color: var(--success);
  /* border: 1px solid var(--success); */
  border-bottom: 3px solid var(--success);
  background-color: #ffffff;
}
</style>
